import api from 'plugin/api';

/**
 *  @description 유효성검증 모니터링(분기)
 */
async function quater(params) {
  const url = '/sfsh/monitoring/procCycleList/validChk';
  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 유효성검증 모니터링(월)
 */
async function month(params) {
  const url = '/sfsh/monitoring/procCycleList/mntr';
  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 공정모니터링상세 - 목록API
 */
async function procResultList(params) {
  const url = '/sfsh/inspection/result';

  const response = await api.get(url, { params });
  return response;
}

export { quater, month, procResultList };
